module.exports = __webpack_public_path__ + "img/安防配件.43528503.jpg";